export default __webpack_public_path__ + "static/media/preflop-equity-handvsrange_0023_thumb.683e2e5b.jpg";